import * as d3 from "d3";

// wrap long x-axis labels
export const Wrapper = (text_orig, width) => {
  text_orig.each(function (x) {
    //Array.prototype.forEach.call(text_orig._groups[0], function (x) {
    var text = d3.select(this);
    var all_tspans = text.selectAll("tspan").size();
    // console.log("all_tspans:", all_tspans);
    if (all_tspans > 1) {
      return;
    }

    var words = text.text().split(/\s+/).reverse();
    var word;
    var lineNumber = 0;
    var lineHeight = 1.1; // ems
    var y = text.attr("y");
    var dy = parseFloat(text.attr("dy"));
    var tspan = text
      .text(null)
      .append("tspan")
      .attr("x", 0)
      .attr("y", y)
      .attr("dy", dy + "em");

    while ((word = words.pop())) {
      tspan = text
        .append("tspan")
        .attr("x", 0)
        .attr("y", y)
        .attr("dy", lineNumber * lineHeight + dy + "em")
        .text(word);
      ++lineNumber;
    }
  });
};
